import(/* webpackMode: "eager" */ "D:\\Github-Agents\\GHA-6\\_work\\FBO\\FBO\\Procom.Phoenix.Web\\Phoenix\\microapps\\t4-salaried-labour-burden-calculator\\app\\page.tsx");
